
import React from 'react';
import { compose, withHandlers } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { container } from 'op/container';
import { Button, Transition, Message } from 'semantic-ui-react';
import { withSafeTimeout } from '@hocs/safe-timers';

import { withNotifications } from './error.helper';

const NotificationArea = styled.div`
	position: fixed;

	top: 1em;
	right: 1em;

	height: auto;
	width: 300px;
`;

const ActionContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

const ErrorsComponent = ({ errors, startDismissTimer, dismissNotification }) => (
	<NotificationArea>
		{ 
			errors
				.filter(({ active }) => !!active)
				.map(({ id, message, details }) => (
					<Message key={id} negative ref={() => startDismissTimer(id)}>
						<Message.Header content={message} />
						<p>{details}</p>
						<ActionContainer>
							<Button color='red' content='Dismiss' onClick={() => dismissNotification(id)} />
						</ActionContainer>
					</Message>
				))
	}			
	</NotificationArea>	
);

export { withErrorHandling } from './error.helper';

export default compose(
	withNotifications,
	withSafeTimeout,
	withHandlers({
		startDismissTimer: ({ setSafeTimeout, dismissNotification }) => 
			(id) => setSafeTimeout(() => dismissNotification(id), 15e3),
	}),
	hot(module),
)(ErrorsComponent);
